import FileKit from "@convertkit/file-kit"

const fetchProviders = accountId => {
  const filekit = FileKit({
    authURL: "/filekit/sessions",
    filekitURL: process.env.FILEKIT_HOST,
    id: accountId
  })

  const fetchProviders = async function(type) {
    const providers = await filekit.allProviders({ type: type })
    return providers
  }

  return fetchProviders
}

export { fetchProviders }
